<template>
  <footer ref="MainContent" data-scroll-section class="footer_bg">
    <!-- ================= Contact+Footer ================= -->
    <section class="relative z-10 w-full">
      <div
        class="relative z-10 w-full px-10 mx-auto max-w-screen-3xl 3xl:px-20"
      >
        <div class="relative z-10 w-full overflow-hidden">
          <div
            class="relative z-10 flex w-full overflow-hidden xl:justify-start"
          >
            <div
              class="w-full relative z-10 px-7 md:px-20 aspect-square md:max-h-[440px] xl:aspect-[1/2] flex flex-col xl:flex-row justify-center xl:items-center xl:justify-start"
            >
              <header class="relative z-10 w-full mb-10 xl:shrink">
                <h4 class="mb-5 text-2xl font-black md:text-3xl text-primary">
                  <small
                    class="block text-base font-black text-justify md:text-xl font-red_hat text-primary"
                    >Contact Us</small
                  >
                  立即免費諮詢
                </h4>
                <p
                  class="w-full text-sm text-justify md:text-base text-primary_dark"
                >
                  有任何貸款相關的問題、疑慮或資金方面的需求都歡迎與我們聯絡
                </p>
              </header>
              <div>
                <a
                  :href="`tel://${$GetColumn('company_phone')}`"
                  target="_blank"
                  class="h-fit w-60 mb-5 px-6 md:px-10 py-3 md:py-4 flex items-center justify-between shrink-0 relative z-10 text-white border-[1.5px] md:border-2 border-primary hover:text-primary hover:bg-transparent bg-primary transition-colors duration-500"
                >
                  <span class="inline-block mr-5 text-sm font-bold"
                    >24小時電話客服</span
                  >
                  <span class="text-sm font-bold icon-arrow-right"></span>
                </a>

                <a
                  :href="`${$GetColumn('company_line')}`"
                  target="_blank"
                  class="h-fit w-60 px-6 md:px-10 py-3 md:py-4 flex items-center justify-between shrink-0 relative z-10 text-primary border-[1.5px] md:border-2 border-primary hover:bg-white transition-colors duration-500"
                >
                  <span class="inline-block mr-5 text-sm font-bold"
                    >線上LINE客服</span
                  >
                  <span class="text-sm font-bold icon-arrow-right"></span>
                </a>
              </div>
            </div>
            <div
              class="absolute top-0 left-0 right-0 bottom-0 z-[1] bg-white opacity-60"
            ></div>
            <img
              data-parallax-image
              src="/img/contact_footer.png"
              alt="立即免費諮詢"
              class="absolute top-0 left-0 w-full h-[200%] z-0 object-cover block"
            />
          </div>
        </div>
      </div>
      <span class="absolute top-0 w-full h-2/4 bg-bg_white"></span>
    </section>
    <!-- ================================================== -->
    <section class="relative z-10 w-full">
      <div
        class="relative z-10 w-full px-10 pb-20 mx-auto max-w-screen-3xl lg:px-20 pt-14 md:pt-20 md:pb-28"
      >
        <div
          class="flex flex-col w-full md:flex-row md:items-start md:justify-between"
        >
          <div class="w-40 mb-10 md:w-64 md:mb-0">
            <img
              src="/img/logo@white.webp"
              :alt="$GetColumn('company_name')"
              class="block w-full"
            />
          </div>

          <div>
            <ul class="w-full">
              <!-- <li class="flex w-full mb-3">
                <span
                  class="inline-block mr-2 text-sm font-bold text-justify w-fit md:text-base text-main_white shrink-0"
                  >公司地址</span
                >
                <span
                  class="inline-block w-full text-sm font-medium text-justify md:text-base text-main_white shrink-1"
                  >{{ $GetColumn("company_address") }}</span
                >
              </li> -->
              <!-- <li class="flex w-full mb-3">
                <span
                  class="inline-block mr-2 text-sm font-bold text-justify w-fit md:text-base text-main_white shrink-0"
                  >諮詢專線</span
                >
                <span
                  class="inline-block w-full text-sm font-medium text-justify md:text-base font-red_hat text-main_white shrink-1"
                  >{{ $GetColumn("company_fax") }}</span
                >
              </li> -->
              <li class="flex w-full mb-3">
                <span
                  class="inline-block mr-2 text-sm font-bold text-justify w-fit md:text-base text-main_white shrink-0"
                  >客服專線</span
                >
                <span
                  class="inline-block w-full text-sm font-medium text-justify md:text-base font-red_hat text-main_white shrink-1"
                  >{{ $GetColumn("company_phone") }}</span
                >
              </li>
              <li class="flex w-full">
                <span
                  class="inline-block mr-2 text-sm font-bold text-justify w-fit md:text-base text-main_white shrink-0"
                  >營業時間</span
                >
                <span
                  class="inline-block w-full text-sm font-medium text-justify md:text-base font-red_hat text-main_white shrink-1"
                  >{{ $GetColumn("company_time") }}</span
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="w-full py-5 bg-primary">
      <div
        class="flex flex-wrap items-center justify-start w-full px-10 mx-auto md:justify-between max-w-screen-3xl 3xl:px-20"
      >
        <p class="mb-3 text-sm font-medium text-main_white md:mb-0">
          ©{{ new Date().getFullYear() }}
          {{ $GetColumn("company_name") }}著作權所有，並保留一切權利。
        </p>

        <div>
          <router-link
            to="/terms/privacy"
            class="text-sm font-medium transition-all duration-300 text-main_white hover:text-opacity-50"
          >
            隱私權政策
          </router-link>
        </div>
      </div>
    </section>
  </footer>
</template>

<script>
import { parallax_image } from "@/gsap/home/parallax_image";
import { mapState, mapGetters } from "vuex";
export default {
  name: "MainFooter",
  data() {
    return {
      parallax_image: null,
    };
  },
  methods: {
    PageInit() {
      this.$emit("load-image");
    },
    SetGsap() {
      this.parallax_image = new parallax_image(this.$refs.MainContent);
    },
  },
  watch: {
    data_load_finish() {
      this.all_data_loaded ? this.PageInit() : "";
    },
    image_loaded() {
      this.image_loaded ? this.SetGsap() : "";
    },
  },
  computed: {
    ...mapState(["image_loaded"]),
    ...mapGetters(["all_data_loaded"]),
  },
};
</script>
